"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Video, DollarSign, Users } from "lucide-react";
export default function KeyFeaturesOverview() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: Video,
    title: "High-Definition Streaming",
    description: "Experience crystal-clear video playback with support for HD content and adaptive streaming technology."
  }, {
    icon: DollarSign,
    title: "Built-in Monetization",
    description: "Generate revenue directly from your audience through seamless ad placement and integrated monetization tools."
  }, {
    icon: Users,
    title: "Community Engagement",
    description: "Foster connections with subscribers through comments, interactions, and customizable channel features."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="key-features-overview" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full shadow-[0_2px_8px_rgba(0,0,0,0.04),0_1px_3px_rgba(0,0,0,0.08)] hover:shadow-[0_4px_16px_rgba(0,0,0,0.12),0_2px_6px_rgba(0,0,0,0.08)] transition-shadow duration-[var(--duration-medium)]">
                  <CardHeader>
                    <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}